exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.organization-nav-link{color:#3b3b3b;font-weight:bold\n}\n.organization-nav-link:hover{color:#00aaef;font-weight:bold\n}\nb-nav-item.active{border-bottom:2px solid gray\n}\n.organization-nav-link-manager{background-color:#ffd966\n}", ""]);

// exports
